import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {
    Button,
    Modal as ReactstrapModal,
    ModalBody,
} from 'reactstrap';
import { toast } from 'react-toastify';

import { API_HOST, HTTP_PROTOCOL } from '../../config';
class ExtremelyLargeItemAlertModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: props.isOpen,
        };
    }

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        handleClose: PropTypes.func.isRequired,
        booking: PropTypes.object.isRequired,
        lines: PropTypes.array.isRequired
    };

    static defaultProps = {
        isOpen: false,
    };

    handleSpecificQuote = () => {
        const token = localStorage.getItem('token');
        let options = {
            method: 'post',
            url: HTTP_PROTOCOL + '://' + API_HOST + '/price/extra-large/',
            headers: {'Authorization': 'JWT ' + token },
            data: {
                booking: this.props.booking,
                lines: this.props.lines
            }
        };

        const closeModal = this.props.handleClose;

        axios(options)
            .then(() => {
                toast('Email sent successfully.');
                closeModal();
            })
            .catch(error => {
                toast('Failed to send email: ' + error);
            });
    }

    render() {
        const { isOpen } = this.props;
        // const {errorMessage, selectedFieldName, postalCodeMin, postalCodeMax, postalCode, findMode} = this.state;

        return (
            <ReactstrapModal
                isOpen={isOpen}
                className="gw-extra-large-item-alert"
                backdrop={true}
                centered={true}
                zIndex={1100}
            >
                <ModalBody>
                    <div className='flex flex-col justify-center text-center'>
                        <div className='flex justify-center'>
                            <span className='warning-icon'><i className='fa fa-exclamation-triangle'></i></span>
                        </div>
                        <h3 className='text-danger font-bold'>Alert: Extremely Large Item(s)</h3>
                    </div>
                    <div className="flex flex-col justify-center p-3 text-center">
                        <p>
                            Your shipment includes items exceeding the standard
                            dimentions supported by our Freight Calculator.
                        </p>
                        <i className="fa fa-arrow-down text-danger font-bold"></i>
                        <p className='mt-3'>
                            If this is incorrect, please update the dimentions
                            and re-run the Freight Calculator.{' '}
                            <span className='text-danger font-bold'>
                                If correct, please contact Customer Support at
                                02 8311 100 to request a specialized quote.
                            </span>
                        </p>
                        <i className="fa fa-arrow-down text-danger font-bold"></i>
                        <p className='mt-3'>
                            A team member will review your request and confirm
                            whether we can accommodate the specified dimentions.
                        </p>
                    </div>
                    <div className='flex justify-center'>
                        <Button color="default" onClick={() => this.handleSpecificQuote()}>
                            Request Specialized Quote
                        </Button>
                        <Button color="primary" onClick={() => this.props.handleClose()}>
                            OK
                        </Button>
                    </div>
                </ModalBody>
            </ReactstrapModal>
        );
    }
}

export default ExtremelyLargeItemAlertModal;



// WEBPACK FOOTER //
// ./src/components/CommonModals/ExtremelyLargeItemAlertModal.js